module.exports = __webpack_public_path__ + "static/images/trash-can-red.bd2260bbd7054d0d115a896a34b78696.svg";